module.exports = __webpack_public_path__ + "img/汉密尔顿.23078ac.png";